import { ValidationSchema, Validators } from "@lemoncode/fonk";
import { createFinalFormValidation } from "@lemoncode/fonk-final-form";
import { requiredByField } from "@lemoncode/fonk-required-by-field-validator";

export const billingValidationSchema: ValidationSchema = {
  field: {
    firstName: [Validators.required],
    lastName: [Validators.required],
    email: [
      Validators.email,
      {
        validator: requiredByField.validator,
        customArgs: {
          field: "sendReceipt",
          value: true,
        },
      },
    ],
    customerNotes: [],
    sendReceipt: [],
    autoCheckIn: [],
  },
};

export const billingValidation = createFinalFormValidation(
  billingValidationSchema
);
